import { RoofProducerEnum } from '../../api/models/roof-producer-enum';
import { RoofProductDto } from '../../api/models/roof-product-dto';
import { ProductsMetaService } from '../cart/products-meta.service';
import { RoofProductTypeEnum } from '../../api/models/roof-product-type-enum';

export class ProductModel {
  readonly id: string;
  readonly producer: RoofProducerEnum;
  readonly name: string;
  readonly description: string;
  readonly specifications: string;
  readonly imageUrl: string | null;
  readonly dimension: string;
  readonly effectiveWidth: number;
  readonly totalWidth: number;
  readonly isTile: boolean;
  constructor(private readonly productDto: RoofProductDto) {
    this.id = productDto.id;
    this.producer = productDto.producer;
    this.name = productDto.name;
    this.description = productDto.description;
    this.specifications = productDto.specifications;
    this.imageUrl = this.productDto.imageUrl ? ProductsMetaService.baseImageUrl + this.productDto.imageUrl : null;
    this.dimension = productDto.dimension;
    this.totalWidth = productDto.totalWidth;
    this.effectiveWidth = productDto.effectiveWidth;
    this.isTile = this.productDto.type === RoofProductTypeEnum.Tile;
  }

  getCustomizedImage(finish: string, color: string): string {
    return ProductsMetaService.getImagePath(this.productDto.type, this.producer, this.name, finish, color);
  }

  // TODO remove this
  getProductDto(): RoofProductDto {
    return this.productDto;
  }
}
